import { useEffect, useState } from 'react';

/**
 * The value, held still until typing stops.
 *
 * For a search box that drives a request. Passing the raw value into
 * `useApiQuery`'s deps fires one request per keystroke — eight for "Sharma" —
 * and the office sees the list flicker through eight answers to reach the one
 * they asked for. The input itself stays uncontrolled by this: what is typed
 * appears immediately, and only the request waits.
 *
 * 300ms by default, which is about the gap between two characters of ordinary
 * typing and short enough that the list feels like it is keeping up.
 */
export function useDebouncedValue<T>(value: T, delayMs = 300): T {
  const [settled, setSettled] = useState(value);

  useEffect(() => {
    const timer = setTimeout(() => setSettled(value), delayMs);
    return () => clearTimeout(timer);
  }, [value, delayMs]);

  return settled;
}
